export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/get.json")),
  ), //make sure all the values are deeply cloned
  {
    groups: ["year 6"],
    category: "text",
    args: {
      arguments: [
        {
          code: {
            type: "string",
            value: "text",
            title: "property",
            "hard-lock": true,
            editable: false,
          },
        },
      ],
    },
  },
);
